<template lang="pug">
  b-container(v-if="user", fluid)
    b-row.mt-3
      b-card-group.w-100(deck)
        b-card(no-body)
          div(slot="header") {{$t('profile')}}
          b-list-group(flush)
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('ID')}}
                b-col(cols="9") {{user.mail}}
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('PW')}}
                b-col(cols="9")
                  div(v-if="!passwd.modify")
                    b-btn.mr-2(size="sm", @click="pwInputChange(true)") {{$t('change')}}
                    b-btn(size="sm", @click="resetPW") {{$t('reset-pw')}}
                  div(v-else)
                    b-form-group(
                      label-size="sm",
                      :description="$t(validatePasswordLevels[this.password_level])",
                      :label="$t('enter_new_password')")
                      b-form-input(type="password", autocomplete="new-password", :state="memberPwState(this.password_level)", v-model.trim="passwd.value", size="sm")
                    b-form-group(
                      label-size="sm",
                      :label="$t('PW_confirm')")
                      b-form-input(type="password", autocomplete="new-password", :state="pwcState", v-model.trim="passwd.confirm", size="sm")
                    b-btn(
                      size="sm",
                      variant="success",
                      :disabled="!memberPwState(this.password_level) || !pwcState",
                      @click="setPassword()",
                      class="mr-2") {{$t('do_change')}}
                    b-btn(size="sm", @click="pwInputChange(false)") {{$t('cancel')}}
            b-list-group-item(v-if="AppState.isCorporate")
              b-row
                b-col(cols="3") {{$t('advenced_auth')}}
                b-col(cols="9")
                  switches.lmm-switch(
                    v-model="useOtp",
                    theme="bootstrap",
                    :color="useOtp ? 'success' : 'default'",
                    @input="toggleChanged('useOtp', 'flag_use_otp')")
                  b-btn.otp-reset-button(size="sm", @click="resetOTP") {{$t('reset_n', {v: 'OTP'})}}
                  div.mt-2
                    small(style="color:#a0a0a0") * {{$t('OTP_desc')}}
            template(v-if="AppState.perm.isApprover")
              // 승인프로세스 적용
              b-list-group-item
                b-row
                  b-col(cols="3") {{$t('approval-apply')}}
                  b-col(cols="9")
                    switches.lmm-switch(
                      v-model="useApproval",
                      theme="bootstrap",
                      :color="useApproval ? 'success' : 'default'",
                      @input="toggleChanged('useApproval', 'use_approval')")
              // 중간관리자  -> 부서장 권한 스위치
              b-list-group-item
                b-row
                  b-col(cols="3") {{$t('submanager-right')}}
                  b-col(cols="9")
                    switches.lmm-switch(
                      v-model="useSubManager",
                      theme="bootstrap",
                      :color="useSubManager ? 'success' : 'default'",
                      @input="toggleSubManager('useSubManager', 'user_type')")
              // 승인자 -> 상위 부서장
              b-list-group-item
                b-row
                  b-col(cols="3") {{$t('approver')}}
                  b-col(cols="9")
                    div {{listener}}
                    b-btn.otp-reset-button(size="sm", @click="onModal") {{$t('change')}}
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('Email')}}
                b-col(cols="9")
                  editable(
                    name="email"
                    :value="user.email",
                    :wait="wait.email",
                    @changed="valueChange")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('name')}}
                b-col(cols="9")
                  editable(
                    name="name"
                    :value="user.name",
                    :wait="wait.name",
                    @changed="valueChange")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('phone')}}
                b-col(cols="9")
                  editable(
                    name="phone"
                    :value="user.phone",
                    :wait="wait.phone",
                    @changed="valueChange")
            //b-list-group-item
            //  b-row
            //    b-col(cols="3") {{$t('office_phone')}}
            //    b-col(cols="9")
            //      editable(
            //        name="tel"
            //        :value="user.tel",
            //        :wait="wait.tel",
            //        @changed="valueChange")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('department')}}
                b-col(cols="9")
                  editable(
                    name="department"
                    :value="user.department",
                    :wait="wait.department",
                    @changed="valueChange")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('cowork_position')}}
                b-col(cols="9")
                  editable(
                    name="position"
                    :value="user.position",
                    :wait="wait.position",
                    @changed="valueChange")
        b-card(no-body)
          div(slot="header") {{$t('setting')}}
          b-list-group(flush)
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('timezone')}}
                b-col(cols="9")
                  tz-select(@changed="timezoneChanged")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('date_format')}}
                b-col(cols="9")
                  b-form-select(
                    size="sm",
                    v-model="dateFormat.value",
                    :options="dateFormat.options",
                    @change="dateFmtChange")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('refresh')}}
                b-col(cols="9")
                  switches.lmm-switch(
                    v-model="useRefresh",
                    theme="bootstrap",
                    :color="useRefresh ? 'primary' : 'default'",
                    @input="toggleChanged('useRefresh', 'flag_refresh')")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('refresh')}} {{$t('time_sec')}}
                b-col(cols="9")
                  editable(
                    name="refresh_interval"
                    :value="user.refresh_interval",
                    :wait="wait.refresh_interval",
                    @changed="valueChange")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('live-view')}} {{$t('auto_update')}}
                b-col(cols="9")
                  switches.lmm-switch(
                    v-model="useLiveviewRefresh",
                    theme="bootstrap",
                    :color="useLiveviewRefresh ? 'primary' : 'default'",
                    @input="toggleChanged('useLiveviewRefresh', 'flag_img_refresh')")
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('live-view')}} {{$t('auto_update')}} {{$t('time_sec')}}
                b-col(cols="9")
                  editable(
                    name="img_refresh_interval"
                    :value="user.img_refresh_interval",
                    :wait="wait.img_refresh_interval",
                    @changed="valueChange")
    b-row.mt-3
      b-card-group.w-100(deck)
        b-card(no-body)
          div.d-flex.justify-content-between(slot="header")
            span {{$t('permission')}}
          b-list-group(flush)
            b-list-group-item
              b-row.my-3
                b-col(cols="2").text-center &nbsp;
                b-col(cols="5").text-center {{$t('target')}}
                b-col(cols="5").text-center {{$t('permission')}}
              b-row.my-3(
                v-for="(perm, i) in permissions",
                v-if="!(perm.target === 'CS_manager' && !AppState.isCorporate)"
                :key="perm.key")
                b-col(cols="2").text-left
                  toggle-box(
                    :field="i",
                    :checked="perm.value",
                    :disabled="perm.disabled || permissionUpdating",
                    @input="permissionChange")
                b-col(cols="5").text-center {{$t(perm.target)}}
                b-col(cols="5").text-center {{$t('permissions.' + perm.key)}}
        b-card(no-body)
          div(slot="header") {{$t('device')}} {{$t('group')}} {{$t('setting')}}
          b-list-group(flush)
            b-list-group-item
              b-row.my-3
                b-col(cols="1").text-center &nbsp;
                b-col(cols="11").text-center {{$t('name')}}
              b-row.my-3(
                v-for="(group, i) in groups",
                :key="group.pk")
                b-col(cols="1").text-center
                  toggle-box(
                    :field="i",
                    :checked="group.connected",
                    @input="groupAccessChange")
                b-col(cols="11").text-left
                  span(style="color:#d4d4d4") {{group.location}}
                  span.text-info {{group.name}}
</template>

<script>
import _ from 'lodash'
import Switches from 'vue-switches'
import {TimezoneConverter} from '@/api/util'
import {UsersAPI, DeviceGroupAPI, ConnDeviceGroupAPI, ApprovalsAPI, CompanyFunctionAPI} from '@/api'
import store from '@/api/store'
import {setDateFmt, FileUploadAPI, setPermission} from '@/api/access'
import Editable from '../mixins/editable'
import TzSelect from '../mixins/tzselect'
import ToggleBox from '../mixins/togglebox'
import AppState from '@/plugins/appstate'

const permTrgLabels = {
  common: 'common',
  web: 'web_manager',
  cs: 'CS_manager'
}

const User = (pk) => {
  return (key, value) => {
    let params = {}
    params[key] = value
    return UsersAPI.put(`${pk}`, params)
  }
}

export default {
  name: 'profile-edit-component',
  props: {
    userPk: {
      type: [String, Number],
      required: true
    }
  },
  components: { Editable, TzSelect, Switches, ToggleBox },
  computed: {
    pwState () {
      return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    pwcState () {
      return this.passwd.value === this.passwd.confirm
    },
    listener () {
      this.AppState.$on('send-department-head-data', data => {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.user.approver_id = data.mgrid
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.user.approver_name = data.name
      })
      return this.user.approver_id + '(' + this.user.approver_name + ')'
    }
  },
  methods: {
    memberPwState (passwordLevel) {
      if (passwordLevel === 0) return /^.{4,12}$/.test(this.passwd.value);
      if (passwordLevel === 1) return /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,12}$/.test(this.passwd.value)
      if (passwordLevel === 2) return /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
      if (passwordLevel === 3) return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    resetOTP () {
      let params = {
        context: {path: 'reset_n', args: {v: 'OTP'}},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: 'submit'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {
          this.userUpdate('flag_create_qrcode', false)
            .then(() => {
              this.AppState.$emit('show-message-dialog', { context: {path: 'otp_reset_complete'} })
            })
            .catch(err => {
              console.error(err)
              this.AppState.$emit('show-message-dialog', { context: {path: 'otp_reset_failed'} })
            })
        }
      })
    },
    resetPW () {
      let params = {
        context: {path: 'reset-pw-repeat'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: 'submit'
        }
      }
      
      const randomPasswordLength = 12
      const randomPassword = this.generateRandomPassword(randomPasswordLength)
      
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {
          // this.AppState.$emit('show-message-dialog', { context: {path: 'reset-pw-submit'} })
          this.userUpdate('pw', randomPassword)
            .then(resp => {
              this.AppState.$emit('show-message-dialog', {
                context: {path: 'reset-pw-submit', args: { password: randomPassword }}
              })
              this.pwInputChange(false)
            })
            .catch(resp => {
              this.AppState.$emit('show-message-dialog', { context: {path: 'password_modified_failed'} })
              this.pwInputChange(false)
            })
        }
      })
    },
    permisionSubmit () {
      this.permissionUpdating = true
      let authVal = 0
      if (this.permissions[0].value === true) authVal += 1 // deviceMonitor
      // if (this.permissions[3].value === true) authVal += 2 // modifyInformation
      if (this.permissions[3].value === true) authVal += 4 // useFunction
      if (this.permissions[4].value === true) authVal += 8 // viewReport

      let params = {
        auth_devicemanagement: _.find(this.permissions, {key: 'CSDeviceManagement'}).value,
        auth_filemanager: _.find(this.permissions, {key: 'CSFileManager'}).value,
        auth_remotecontrol: _.find(this.permissions, {key: 'CSRemoteControl'}).value,
        // auth_remoteview: _.find(this.permissions, {key: 'CSRemoteView'}).value,
        auth_restart: _.find(this.permissions, {key: 'CSRestart'}).value,
        auth_thumbnailview: _.find(this.permissions, {key: 'CSThumbnailView'}).value,
        auth_update: _.find(this.permissions, {key: 'CSUpdate'}).value,
        auth_val: authVal
      }

      UsersAPI.put(`${this.userPk}`, params)
        .then(resp => {
          this.permissionUpdating = false
        })
    },
    permissionChange (index, value) {
      this.permissions[index].value = value
      this.permisionSubmit()
    },
    groupAccessChange (index, value, restore) {
      const {pk} = this.groups[index]
      if (value) {
        let params = {
          device_group_fk: pk,
          member_fk: this.userPk
        }
        ConnDeviceGroupAPI.post('', params)
          .then(() => {
            ConnDeviceGroupAPI.get('', {params})
              .then(resp => {
                this.groups[index].connectedPk = resp.data.objects[0].pk
                this.groups[index].connected = true
              })
          })
      }
      else {
        ConnDeviceGroupAPI.delete(`${this.groups[index].connectedPk}`)
          .then(() => {
            this.groups[index].connectedPk = null
            this.groups[index].connected = false
          })
      }
    },
    // 하위 그룹 권한을 생성/제거시 상위 그룹에 영향을 받음
    // 2018-11-28 헬스케어 관련 수정으로 기능을 없앰
    groupAccessChange_backup (index, value, restore) {
      const {pk, path, child} = this.groups[index]

      if (value) {
        if (path.length) {
          let notConnectedParents = path.filter(v => !v.connected)
          if (notConnectedParents.length) {
            restore(false)

            let params = {
              context: {path: 'add_permission_of_group', args: {groups: notConnectedParents.map(v => v.name).join(', ')}},
              withoutInput: true,
              submit: {
                size: 'sm',
                color: 'primary',
                text: {path: 'submit'}
              }
            }
            this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
              if (key !== 'submit') return
              // 상위 장치그룹 허용
              _.each(notConnectedParents, parent => {
                let params = {
                  device_group_fk: parent.pk,
                  member_fk: this.userPk
                }
                ConnDeviceGroupAPI.post('', params)
                  .then(() => {
                    ConnDeviceGroupAPI.get('', {params})
                      .then(resp => {
                        parent.connectedPk = resp.data.objects[0].pk
                        parent.connected = true
                      })
                  })
              })
              // 장치그룹 허용
              let params = {
                device_group_fk: pk,
                member_fk: this.userPk
              }
              ConnDeviceGroupAPI.post('', params)
                .then(() => {
                  ConnDeviceGroupAPI.get('', {params})
                    .then(resp => {
                      this.groups[index].connectedPk = resp.data.objects[0].pk
                      this.groups[index].connected = true
                    })
                })
            })
            return
          }
        }
        // 상위 그룹이 다 허용된 경우
        let params = {
          device_group_fk: pk,
          member_fk: this.userPk
        }
        ConnDeviceGroupAPI.post('', params)
          .then(() => {
            ConnDeviceGroupAPI.get('', {params})
              .then(resp => {
                this.groups[index].connectedPk = resp.data.objects[0].pk
                this.groups[index].connected = true
              })
          })
      } else {
        if (child.length) {
          let connectedParents = child.filter(v => v.connected)
          if (connectedParents.length) {
            restore(true)

            let params = {
              context: {path: 'delete_permission_of_group', args: {groups: connectedParents.map(v => v.name).join(', ')}},
              withoutInput: true,
              submit: {
                size: 'sm',
                color: 'primary',
                text: {path: 'submit'}
              }
            }
            this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
              if (key !== 'submit') return
              // 하위 장치그룹 권한 제거
              _.each(connectedParents, children => {
                ConnDeviceGroupAPI.delete(`${children.connectedPk}`)
                  .then(() => {
                    children.connectedPk = null
                    children.connected = false
                  })
              })
              // 장치그룹 권한 제거
              ConnDeviceGroupAPI.delete(`${this.groups[index].connectedPk}`)
                .then(() => {
                  this.groups[index].connectedPk = null
                  this.groups[index].connected = false
                })
            })
            return
          }
        }

        ConnDeviceGroupAPI.delete(`${this.groups[index].connectedPk}`)
          .then(() => {
            this.groups[index].connectedPk = null
            this.groups[index].connected = false
          })
      }
    },
    pwInputChange (state) {
      this.passwd.modify = state
      this.passwd.value = ''
      this.passwd.confirm = ''
    },
    setPassword () {
      this.userUpdate('pw', this.passwd.value)
        .then(resp => {
          this.AppState.$emit('show-message-dialog', { context: {path: 'password_modified'} })
          this.pwInputChange(false)
        })
        .catch(resp => {
          this.AppState.$emit('show-message-dialog', { context: {path: 'password_modified_failed'} })
          this.pwInputChange(false)
        })
    },
    dateFmtChange (value) {
      this.userUpdate('date_fmt_id', value)
        .then(resp => {
          let r = setDateFmt(value)
          this.AppState.Info.dateFmt = r.value
        })
    },
    uploadLogo (data) {
      var file = null
      if (data.target) file = data.target.files[0]
      else file = data
      const fd = new FormData()
      fd.append('file', file)

      FileUploadAPI.post('', fd)
        .then(resp => {
          this.AppState.$emit('logo-changed')
          this.timestamp = new Date().getTime()
        })
    },
    toggleChanged (dataKey, dbKey) {
      if (!this.pageMounted) return
      this.userUpdate(dbKey, this[dataKey])
    },
    async toggleSubManager (dataKey, dbKey) {
      let params = this.user.member_type_id
      if (this.useSubManager) {
        params = 6
      } else if (this.useAdmin) {
        params = 2
      }
      this.userUpdate(dbKey, params)
    },
    valueChange (key, value) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      this.wait[key] = true
      this.userUpdate(key, value)
        .then(resp => {
          this.wait[key] = false
        })
    },
    async approverChange (key, value) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      this.wait[key] = true
      let params = {
        name: value
      }
      const resp=await ApprovalsAPI.get('search', {params})
      if (resp.data.status === 200) {
        let params = {
          approver_fk: resp.data.objects[0].pk,
          user_type: this.user.member_type_id
        }
        UsersAPI.put(`${this.userPk}`, params)
          .then(resp => {
            // this.AppState.$emit('show-message-dialog', {
            //   title: 'LinkMeMine',
            //   context: {path: 'search_manager_200'}
            // })
            this.wait[key] = false
          })
      } else {
        let params = {
          context: {path: 'search_manager_405'},
          withoutInput: true,
          withoutCancel: true,
          submit: {
            size: 'sm',
            color: 'danger',
            text: 'submit'
          }
        }
        this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
          if (key === 'submit') {
            this.$router.go(this.$router.currentRoute)
          }
        })
      }
      this.wait[key] = false
    },
    timezoneChanged (tz) {
      let id = TimezoneConverter('offset', tz.offset)
      if (id) {
        let tzv = _.assign({}, id, tz)
        this.AppState.Info.timezone = tzv
        this.AppState.$emit('timezone-changed')
      }
    },
    getUserData () {
      UsersAPI.get(`${this.userPk}`)
        .then(resp => {
          let user = resp.data.objects
          this.dateFormat.value = user.date_fmt_id
          this.useOtp = user.flag_use_otp
          this.useRefresh = user.flag_refresh
          this.useLiveviewRefresh = user.flag_img_refresh
          this.useApproval = user.use_approval
          this.timestamp = new Date().getTime()
          let perms = setPermission(user, true)
          _.each(this.permissions, v => {
            if (perms[v.key]) {
              v.value = perms[v.key]
            }
          })
          this.user = user
          this.userUpdate = User(user.pk)
          this.$nextTick(() => {
            this.pageMounted = true
          })
          // disable_filetransfer
          if (user.disable_filetransfer) {
            for (let i = 0; i<this.permissions.length; i++){
              if (this.permissions[i].key == 'CSFileManager') {
                this.permissions[i].disabled = true
              }
            }
          }

          // 중간관리자권한 GET
          if (user.member_type_id === 6) {
            this.useSubManager = true
          } else if (user.member_type_id === 1) {
            this.useSubManager = false
          } else if (user.member_type_id === 2) {
            this.useAdmin = true
          }
        })
    },
    getConnGroups () {
      _.each(this.groups, (v, i) => {
        let params = {
          device_group_fk: v.pk,
          member_fk: this.userPk
        }
        ConnDeviceGroupAPI.get('', {params})
          .then(resp => {
            if (resp.data.status === 404) return
            if (resp.data.objects === null) return
            this.groups[i].connected = true
            this.groups[i].connectedPk = resp.data.objects[0].pk
          })
      })
    },
    getGroups () {
      const pushParent = (groups, order, path, group) => {
        let g = groups.filter(v => v.pk === group.group_fk)
        if (g.length) {
          g = g[0]
          path.unshift(g)
          order.unshift(g.name[0].charCodeAt())
          if (g.group_fk) pushParent(groups, order, path, g)
        }
      }
      const pushChild = (groups, child, group) => {
        let g = groups.filter(v => v.group_fk === group.pk)
        if (g.length) {
          child.push.apply(child, g)
          _.each(g, c => pushChild(groups, child, c))
        }
      }
      const groupSort = (groups) => {
        groups = groups.map(v => {
          let path = []
          let child = []
          let order = v.name ? [v.name[0].charCodeAt()] : [0]
          if (v.group_fk) pushParent(groups, order, path, v)
          pushChild(groups, child, v)
          v.location = path.length ? '/' + path.map(v => v.name).join('/') + '/' : '/'
          v.path = path
          v.child = child
          v.order = order
          v.order1 = order.length * -1
          v.connected = false
          v.connectedPk = null
          return v
        })
        this.groups = _.sortBy(groups, ['order', 'order1'])
        this.getConnGroups()
      }
      let stored = store.get('devices')
      if (stored.groups) {
        let groups = stored.groups
        groupSort(groups)
      } else {
        DeviceGroupAPI.get('')
          .then(resp => {
            let groups = resp.data.objects
            groupSort(groups)
          })
      }
    },
    onModal () {
      let params = {
        title: 'LinkMeMine',
        context: {path: 'middle_manager_list_modal'},
        userPk: this.userPk,
        userType: this.user.member_type_id
      }
      this.AppState.$emit('show-list-modal-dialog', params)
    },
    generateRandomPassword (length) {
      const characters = 'abcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
      let password = '';
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        password += characters[randomIndex];
      }
      return password;
    },
    async getData () {
      const resp=await CompanyFunctionAPI.get()
      this.password_level = resp.data.objects[0].password_level
    }
  },
  created () {
    this.getUserData()
    this.getGroups()
    this.getData()
  },
  data () {
    return {
      password_level: null,
      timestamp: 0,
      groups: [],
      pageMounted: false,
      user: null,
      managedUser: {},
      wait: {
        email: false,
        name: false,
        phone: false,
        tel: false,
        department: false,
        position: false,
        refresh_interval: false,
        approver_name: false
      },
      useOtp: false,
      useRefresh: false,
      useLiveviewRefresh: false,
      useApproval: false,
      useSubManager: false,
      useAdmin: false,
      dateFormat: {
        value: null,
        options: [
          {value: 0, text: 'YYYY/MM/DD'},
          {value: 1, text: 'MM/DD/YYYY'},
          {value: 2, text: 'DD/MM/YYYY'}
        ]
      },
      passwd: {
        modify: false,
        value: '',
        confirm: ''
      },
      permissionUpdating: false,
      validatePasswordLevels: [
        this.$t('password_level0'),
        this.$t('password_level1'),
        this.$t('password_level2'),
        this.$t('password_level3'),
      ],
      permissions: [
        {
          key: 'deviceMonitor',
          target: permTrgLabels.common,
          value: false,
          disabled: true
        },
        {
          key: 'CSRemoteControl',
          target: permTrgLabels.common,
          value: false
        },
        {
          key: 'CSFileManager',
          target: permTrgLabels.common,
          value: false,
          disabled: false
        },
        // {
        //   key: 'modifyInformation',
        //   target: permTrgLabels.web,
        //   value: false
        // },
        {
          key: 'useFunction',
          target: permTrgLabels.web,
          value: false
        },
        {
          key: 'viewReport',
          target: permTrgLabels.web,
          value: false
        },
        // {
        //   key: 'CSRemoteView',
        //   target: permTrgLabels.cs,
        //   value: false
        // },
        {
          key: 'CSDeviceManagement',
          target: permTrgLabels.cs,
          value: false
        },
        {
          key: 'CSUpdate',
          target: permTrgLabels.cs,
          value: false
        },
        {
          key: 'CSThumbnailView',
          target: permTrgLabels.cs,
          value: false
        },
        {
          key: 'CSRestart',
          target: permTrgLabels.cs,
          value: false
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  display: inline-block;
  width: 40%;
  min-width: 80px;
  max-width: 120px;
}
.profile-image {
  max-width: 240px;
  margin: 0 auto;
  overflow: hidden;
}
.logo-wrap {
  position: relative;
}
.profile-image-upload {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  margin: 0;
  z-index: 10;
  overflow: hidden;
  display: block;
  background-color: rgba(0,0,0,0.3);
  cursor: pointer;
  opacity: 0;
  transition: opacity 300ms;
  &.dragover,
  &:hover {
    opacity: 1
  }

  .upload-icon {
    display: block;
    margin: 12px auto 0;
    color: #fff;
  }
}

#upload {
  position: absolute;
  bottom: -30px;
}
.otp-reset-button {
  position: absolute;
  top: -6px; right: 5px;
}

.card {
  margin-right: 0 !important;
}
</style>
